"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveColor = void 0;
const colors_1 = require("../../shared/constants/colors");
const statusColorMap = {
    OK: colors_1.colors.greenBase,
    WARN: colors_1.colors.yellowBase,
    ALERT: colors_1.colors.pinkBase
};
const resolveColor = (status) => statusColorMap[status] || colors_1.colors.greyBase;
exports.resolveColor = resolveColor;
//# sourceMappingURL=utils.js.map